import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { AtwFrameCategoriesAdmin } from '../../admin/frame-categories-admin/frame-categories-admin.component';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LanguageService } from 'vhobjects-service/src/services';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-frame-categories-admin-config',
  templateUrl: './frame-categories-admin-config.component.html',
  styleUrls: ['./frame-categories-admin-config.component.scss']
})
export class AtwFrameCategoriesAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any;
  @Output() changeOptionConfig = new EventEmitter<any>();

  width = 0;
  height = 0;
  public isViewAll: boolean = false;
  public currentViewAll: any = {};
  // Xử lý chỉ mở được 1 menu 1 lần
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  };
  public urlBackgroundImage = ''; // Hình ảnh nền của frame (nếu có)
  public gapSpace = 0;
  public loadComplete = false;
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien_icon_trai',
      index: 3,
    },
    {
      title: 'dieu_chinh_vien_icon_phai',
      index: 4,
    },
    {
      title: 'hieu_ung',
      index: 5,
    },
    {
      title: 'nang_cao',
      index: 6,
    },
    {
      title: 'nang_cao',
      index: 7,
    },
    {
      title: 'dieu_chinh_vien_phan_tu_active',
      index: 8,
    },
    {
      title: 'nang_cao',
      index: 9,
    },
  ];
  classUpdates = {
    "frame-categories__pagination": {
      "background-color": "rgb(255, 255, 255)",
      "align-items": "center",
      "height": "50px",
      "display": "flex",
      "width": "100%",
      "margin-top": "10px",
      "justify-content": "center"
    },
    "frame-categories__pagination-list-button": {
      "background-color": "transparent",
      "font-family": "Arial",
      "font-size": "16px",
      "gap": "0px",
      "display": "flex",
      "color": "green"
    },
    "frame-categories__pagination-list-button--controll": {
      "align-items": "center",
      "border-style": "solid",
      "border-color": "#dddddd",
      "justify-content": "center",
      "font-size": "16px",
      "padding": "8px 16px",
      "color": "inherit",
      "display": "flex",
      "cursor": "pointer",
      "background-color": "#fff",
      "border-width": "1px",
      "font-family": "inherit"
    },
    "frame-categories__pagination-list-button--page-number": {
      "font-size": "16px",
      "padding": "8px 16px",
      "display": "flex",
      "align-items": "center",
      "border-width": "1px",
      "background-color": "#fff",
      "border-style": "solid",
      "border-radius": "0px",
      "color": "#000",
      "font-family": "inherit",
      "cursor": "pointer",
      "border-color": "#ddd",
      "justify-content": "center"
    },
    "frame-categories__pagination-list-button--active": {
      "color": "#fff",
      "border-width": "1px",
      "font-family": "inherit",
      "cursor": "pointer",
      "justify-content": "center",
      "border-color": "#ddd",
      "background-color": "#008000",
      "padding": "8px 16px",
      "border-style": "solid",
      "align-items": "center",
      "display": "flex",
      "font-size": "16px"
    },
    "frame-categories__left-arrow--icon": {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    "frame-categories__right-arrow--icon": {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
    }
  };
  configUpdates = {
    "left_arrow_icon_shadow": {
      "property_box_shadow": {
        "spread": 1,
        "type": "outset",
        "v-offset": 1,
        "h-offset": 1,
        "color": "#ffffffff",
        "blur": 1
      },
      "is_box_shadow": false
    },
    "right_arrow_icon_shadow": {
      "property_box_shadow": {
        "spread": 1,
        "type": "outset",
        "v-offset": 1,
        "h-offset": 1,
        "color": "#ffffffff",
        "blur": 1
      },
      "is_box_shadow": false
    },
    "goToPage_pagination": {
      "border_color": "#ddd",
      "color": "green",
      "border_style": "solid",
      "content_goToPage": "Tới trang",
      "background_color": "#fff",
      "font_size": 16,
      "border_radius": 0,
      "display": false,
      "border_width": 1
    },
    "content_pagination": {
      "content_left": "Trước",
      "content_right": "Sau"
    },
    "slick_dots": {
      "height": "41px",
      "border_radius": 0,
      "width": "58px",
      "background_style": "rectangle"
    },
    "animation-selected": {
      "id": "000000"
    },
    "frame-categories__pagination": {
      "hide_pagination": false
    },
    "type_display": "slide",
    "icon_pagination": {
      "icon": true,
      "color": "green",
      "font_size": 16,
      "arrow_left_icon": "bi bi-chevron-left",
      "display": false,
      "background_color": "#fff",
      "border_radius": 0,
      "border_color": "#ddd",
      "arrow_right_icon": "bi bi-chevron-right",
      "border_width": 1
    },
    "background-color": {
			"gradient_arr": [
				"rgb(0, 0, 255)",
				"rgb(255, 255, 0)"
			],
			"background": "#8c52ff",
			"gradient_check": false,
			"value_range": 1,
			"gradient_type": "linear-gradient",
			"value_parameter": 100,
			"gradient_direction": ""
		},
    "background-color-item": {
			"gradient_arr": [
				"rgb(0, 0, 255)",
				"rgb(255, 255, 0)"
			],
			"background": "#8c52ff",
			"gradient_check": false,
			"value_range": 1,
			"gradient_type": "linear-gradient",
			"value_parameter": 100,
			"gradient_direction": ""
		},
  }
  gradientConfigMap = {
    5: {
      configKey: 'background-color',
      classKey: 'frame-categories'
    },
    6: {
      configKey: 'background-color-item',
      classKey: 'frame-categories__products--item'
    },
    8: {
      configKey: 'background-color-item-active',
      classKey: 'frame-categories__products--item-active'
    }
  };
  animation: any = {};
  effect_hover = [];
  customize = [];
  configMode: 'basic' | 'advanced' = 'basic';
  fonts: any = [];


  public bootstrapIconArrows: any = [
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right',
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short',
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill',
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right',
    },
  ];

  editContentSubs: any;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    private nzModalService: NzModalService,
    private languageService: LanguageService,
    public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      for (const key in this.classUpdates) {
        if (!this.class.hasOwnProperty(key)) {
          this.objectChoosing[this.device + '_class'][key] = this.class[key] = this.classUpdates[key];
        } else {
          for (const key2 in this.classUpdates[key]) {
            if (!this.class[key].hasOwnProperty(key2)) {
              this.objectChoosing[this.device + '_class'][key][key2] = this.class[key][key2] = this.classUpdates[key][key2];
            }
          }
        }
      }
      for (const key in this.configUpdates) {
        if (!this.config.hasOwnProperty(key)) {
          this.objectChoosing[this.device + '_config'][key] = this.config[key] = this.configUpdates[key];
        } else {
          for (const key2 in this.configUpdates[key]) {
            if (!this.config[key].hasOwnProperty(key2)) {
              this.objectChoosing[this.device + '_config'][key][key2] = this.config[key][key2] = this.configUpdates[key][key2];
            }
          }
        }
      }
      if (this.class && this.config) {
        this.loadComplete = true;
        // Khoảng cách giữa cột và dòng
        this.gapSpace = parseInt(
          this.class['frame-categories__products']['gap'],
          10
        );
      }
      // phần này get dữ liệu json
      forkJoin([
        this.http.get('assets/fonts/fonts.json'),
        this.http.get('assets/data/effects/frame-products.json')
      ]).subscribe(([fonts, effects]: any) => {
        this.effect_hover = effects;
        this.fonts = fonts;
      })
    }


    this.editContentSubs = this.vhEventMediator.configChanged
      .subscribe(async (message: any) => {
        if (message) {
          if (message.status === "edit-content" && message.code == this.objectChoosing._id) {
            this.openModalEdit();
          }
        }
      });
  }

  ngOnChanges() {
    if (this.objectChoosing.component == 'AtwFrameDisplaySubcategory') {
      this.config.data_type_same_category ??= {};
      this.class["frame-categories__products--item-active"] ??= {
        "background-color": "transparent",
        "border-bottom-left-radius": "6px",
        "border-style": "solid",
        "border-color": "#007e42",
        "border-bottom-width": "1px",
        "border-top-width": "1px",
        "border-left-width": "1px",
        "box-shadow": "",
        "border-right-width": "1px",
        "border-top-left-radius": "6px",
        "border-top-right-radius": "6px",
        "border-bottom-right-radius": "6px"
      };
      this.config["frame-categories__products--item-active"] ??= {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "v-offset": 1,
          "blur": 1,
          "h-offset": 1,
          "color": "#ffffffff",
          "spread": 1
        }
      };
      this.config["background-color-item-active"] ??= {
        "gradient_arr": [
          "rgb(0, 0, 255)",
          "rgb(255, 255, 0)"
        ],
        "background": "#8c52ff",
        "gradient_check": false,
        "value_range": 1,
        "gradient_type": "linear-gradient",
        "value_parameter": 100,
        "gradient_direction": ""
      };
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.editContentSubs?.unsubscribe();
  }


  // hàm cập nhật background linear-gradient
  updateBackgroundRgb(viewMoreIndex) {  
    const configData = this.gradientConfigMap[viewMoreIndex];
    if (!configData) return;
  
    const { configKey, classKey } = configData;
    const bgConfig = this.config[configKey];
    const gradient = bgConfig.gradient_check
      ? `linear-gradient(${bgConfig.gradient_direction}${bgConfig.gradient_arr})`
      : 'none';
  
    this.class[classKey]['background-image'] = gradient;
    this.updateObject();
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value, viewMoreIndex) {
    if (!value.includes('#')) return;

    const configData = this.gradientConfigMap[viewMoreIndex];
    if (!configData) return;
  
    const { configKey } = configData;
    const gradient = this.config[configKey];
    gradient.gradient_arr.push(`rgba(${this.hexToRGB(value)}, ${gradient.value_range})`);
    this.updateBackgroundRgb(viewMoreIndex);
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index, viewMoreIndex) {
    const configData = this.gradientConfigMap[viewMoreIndex];
    if (!configData) return;
  
    const { configKey } = configData;
    const configBg = this.config[configKey];
    if (configBg[`gradient_arr`].length > 1) {
      configBg[`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb(viewMoreIndex)
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event, viewMoreIndex) {
    if (!isPlatformBrowser(this.platformId)) return;

    const configData = this.gradientConfigMap[viewMoreIndex];
    if (!configData) return;
  
    const { configKey, classKey } = configData;
    const configBg = this.config[configKey];
    // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
    configBg.gradient_type = direction.type;
    configBg.gradient_direction = direction.direction;
    this.class[classKey]['background-image'] = 
      configBg.gradient_type + '(' + configBg.gradient_direction + configBg.gradient_arr.join(',') + ')';
    this.updateObject();
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện kiểm tra điều kiện 1 hướng của viền và active option đấy nếu đủ điều kiện
   *
   * @param value
   */
  checkActiveDirectionBorder(value: any) {
    if (['0px', '0'].includes(value)) return false;
    return true;
  }
  //Hàm update class
  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //     })
  //     .then((bool: any) => {

  //     });
  // }

  // //Hàm update class
  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //     })
  //     .then((bool: any) => {

  //     });
  // }
  // //Hàm update position
  // updatePosition() {
  //   this.vhQueryAutoWeb
  //     .updateBlock(this.objectChoosing._id, {
  //       [this.device + 'position']: this.position,
  //     })
  //     .then((bool: any) => {

  //     });
  // }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[4]);
  }

  openModalEdit() {
    const mapComponent = {
      "AtwFrameCategories": AtwFrameCategoriesAdmin,
    }
    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: this.languageService.translate('chinh_sua_noi_dung'),
      nzWidth: '80%',
      nzContent: mapComponent[this.objectChoosing.component],
      nzComponentParams: {
        data: this.objectChoosing,
        type: 'page'
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
      // this.vhEventMediator.notifyOnConfigChanged({
      //   status: 'config-changed',
      //   code: this.objectChoosing._id,
      // });
    });
  }

  /**
 * Kiểu nút slide
 * @param event
 */
  handleSetDotsStyle(event) {
    switch (event) {
      case 'circle':
        this.class['frame-categories__pagination-list-button--controll'][
          'border-radius'
        ] = 50 + 'px';
        this.class[
          'frame-categories__pagination-list-button--page-number'
        ]['border-radius'] = 50 + 'px';
        this.class['frame-categories__pagination-list-button--active'][
          'border-radius'
        ] = 50 + 'px';
        this.config[`slick_dots`]['height'] =
          this.config[`slick_dots`]['width'];
        break;
      case 'rectangle':
        this.class['frame-categories__pagination-list-button--controll'][
          'border-radius'
        ] = 0 + '%';
        this.class[
          'frame-categories__pagination-list-button--page-number'
        ]['border-radius'] = 0 + '%';
        this.class['frame-categories__pagination-list-button--active'][
          'border-radius'
        ] = 0 + '%';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  /**
 * Kích thước cho nút next/prev
 *  @param event
 *  @param type nút next hay prev
 */
  handleSetButtonSize(event) {
    var style = this.config[`slick_dots`]['background_style'];

    this.config[`slick_dots`]['width'] = event + 'px';
    this.config['slick_dots']['height'] = event + 'px';
    this.class['frame-categories__pagination-list-button--controll'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-categories__pagination-list-button--page-number'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-categories__pagination-list-button--active'][
      'border-radius'
    ] = 50 + 'px';
  }

  /*--------- Thay đổi mũi tên điều hướng trang -------------------*/
  onChangeArrows(arrows) {
    this.config.icon_pagination.arrow_left_icon = arrows.icon_left;
    this.config.icon_pagination.arrow_right_icon = arrows.icon_right;
    this.updateConfig();
  }


}
